import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=3020e6dc&scoped=true"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"
import style0 from "./Monitor.vue?vue&type=style&index=0&id=3020e6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3020e6dc",
  null
  
)

export default component.exports